module.exports = function(a, b) {
   var ai=0, bi=0;
  var result = [];

  while( ai < a.length && bi < b.length )
  {
     if      (a[ai] < b[bi] ){ ai++; }
     else if (a[ai] > b[bi] ){ bi++; }
     else /* they're equal */
     {
       result.push(a[ai]);
       ai++;
       bi++;
     }
  }

  return result;

}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/helpers/array-intersection.js